import { render, staticRenderFns } from "./ProjectCommentsStreams.vue?vue&type=template&id=308974a7&"
import script from "./ProjectCommentsStreams.vue?vue&type=script&lang=js&"
export * from "./ProjectCommentsStreams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports